var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJoinRightOuter = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 11.75c.726 0 1.403-.206 1.978-.563.231.256.49.486.772.686a4.75 4.75 0 1 1 0-7.747c-.282.201-.54.431-.772.687A3.75 3.75 0 1 0 5.25 11.75zm1.978-6.937A3.748 3.748 0 0 1 9 8a3.748 3.748 0 0 1-1.772 3.187A4.733 4.733 0 0 1 6 8c0-1.226.465-2.344 1.228-3.187zm3.522 7.937A4.728 4.728 0 0 1 8 11.873c1.21-.86 2-2.275 2-3.873 0-1.598-.79-3.013-2-3.873a4.75 4.75 0 1 1 2.75 8.623z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJoinRightOuter);
export default ForwardRef;